import React, { useState, useEffect, useRef } from "react";
import "./style.scss";

import arrow from "./img/arrow.png";
import awe from "./img/awe.jpg";
import aweBG from "./img/awe-bg.jpg";
import hpe from "./img/hpe.jpg";
import siemens from "./img/siemens.jpg";
import ReadMore from "../../../common/ReadMore";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import privateCohortBtn from "../../../../assets/svg/shield2.svg";
import {
  ALL_COHORT_PROGRAMS,
  ADMIN_DASHBOARD_SPOTLIGHT_LIST,
} from "../../../common/constants/ApplicationUrl";
import api from "../../../common/dependencies/utils/Api";
import ModalFilter2 from "../../../common/modalFilter2";
import axios from "axios";
import Slider from "react-slick";

import hashImage from "../../../../assets/images/hashImage.jpeg";
import swal from "sweetalert";
import Modal from "./Modal/modal";

export default function ActiveProgram(props) {
  const loginDataJson = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const cohortRole = loginDataJson?.role;
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [text, setText] = useState("");
  const [data, setData] = useState([]);
  const [modalVisibility2, setModalVisibility2] = useState();
  // const pushbtnviewcohort = useRef();

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: data?.length > 2 ? 3 : data.length,
    // slidesToShow:data?.engagement.length > 2 ? 3 : data?.engagement.length ,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    let params = {
      cohortId: "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: "",
      function: "",
      stage: "",
      searchField: "",
      searchKey: null,
      status: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    api
      .POST(ADMIN_DASHBOARD_SPOTLIGHT_LIST, params)
      .then((res) => {
        // setData(res.data?.data);
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    let params = {
      cohortId: "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: "",
      function: "",
      stage: "",
      searchField: "",
      searchKey: null,
      status: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 100,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    api
      .POST(ADMIN_DASHBOARD_SPOTLIGHT_LIST, params)
      .then((res) => {
        setData(res.data?.data);
        // console.log("RESPONSE API", res?.data?.data);
      })
      .catch((err) => {});
  }, []);
  // useEffect(() => {
  //   // axios({
  //   //   url: ALL_COHORT_PROGRAMS,
  //   //   method: "post",
  //   //   data: {
  //   //     status: "VERIFIED",
  //   //     sortKey: "name",
  //   //     sortOrder: "ASC",
  //   //     country: null,
  //   //     state: null,
  //   //     industry: null,
  //   //     function: null,
  //   //     stage: null,
  //   //     searchField: null,
  //   //     searchKey: null,
  //   //     pageFilter: {
  //   //       currentPage: 0,
  //   //       includeCount: true,
  //   //       pageSize: 10,
  //   //       sortField: "date_applied",
  //   //       sortOrder: "DESC",
  //   //     },
  //   //   },
  //   // })

  //   api
  //     .POST(ALL_COHORT_PROGRAMS, {
  //       status: "VERIFIED",
  //       sortKey: "name",
  //       sortOrder: "ASC",
  //       country: null,
  //       state: null,
  //       industry: null,
  //       function: null,
  //       stage: null,
  //       searchField: null,
  //       searchKey: null,
  //       pageFilter: {
  //         currentPage: 0,
  //         includeCount: true,
  //         pageSize: 10,
  //         sortField: "date_applied",
  //         sortOrder: "DESC",
  //       },
  //     })
  //     .then((res) => {
  //       setData(res.data?.data);
  //     })
  //     .catch((err) => {});
  // }, []);

  return (
    <>
      {/* {props.fromPage && props.fromPage === "mentorDashboard" && (
        <a
          className={"col-md-12  btn btn-primary "}
          style={{
            marginTop: "-37%",
            cursor: "pointer",
            height: "fit-content",
            textDecoration: "none",
            background: "transparent",
            // display: "none",
          }}
          ref={props.pushbtnviewcohort}
          href="#viewallcohortsdiv"
        >
          City Level
        </a>
      )} */}

      <div className="activce-program">
        <Modal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modalData={modalData}
        />
        {data?.length > 0 && (
          <section
            style={{
              backgroundImage:
                "linear-gradient(to right, #8E9FD9, #B5CFEC, #8E9FD9)",
            }}
            id="ap"
          >
            {/* <div class="col-md-6 col-lg-6">
                <ul class="nav nav-tabs">
                  <li class="nav-item wow fadeInDown newuserTooltip">
                    <button
                      class="nav-link active"
                      data-bs-toggle="tab"
                      data-bs-target="#description"
                      type="button"
                    >
                      Active Programs
                    </button>
                    <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{ left: "60px",
                                    top: "50px",
                                    width: "210px",
                                    padding: "0px 10px",}}
                                >
                                  Click to View Active Programs
                                </span>
                  </li>

                  <li class="nav-item wow fadeInDown newuserTooltip">
                    <button
                      class="nav-link "
                      data-bs-toggle="tab"
                      data-bs-target="#reviews"
                      type="button"
                    >
                      Closed Programs
                    </button>
                    <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{ left: "60px",
                                    top: "50px",
                                    width: "210px",
                                    padding: "0px 10px",}}
                                >
                                  Click to View Closed Programs
                                </span>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="filter-sec">
                  <ul class="filter wow fadeInDown">
                    <li>
                      {" "}
                      <p class="mb-0">FILTER BY</p>
                    </li>
                    <li className="newuserTooltip">
                      <select class="thm-btn brd-btn d-inline-block">
                        <option value="English" selected>
                          INDUSTRY
                        </option>
                        <option value="Hindi">INDUSTRY</option>
                      </select>
                      <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{ left: "77px", top: "40px",width:"130px",padding:"0px 10px"}}
                                >
                                  Search Industry
                                </span>
                    </li>
                    <li className="newuserTooltip">
                      <select class="thm-btn brd-btn d-inline-block">
                        <option value="English" selected>
                          FUNCTION
                        </option>
                        <option value="Hindi">FUNCTION</option>
                      </select>
                      <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{ left: "77px", top: "40px",width:"130px",padding:"0px 10px" }}
                                >
                                  Search Function
                                </span>
                    </li>
                    <li className="newuserTooltip">
                      <select class="thm-btn brd-btn d-inline-block">
                        <option value="English" selected>
                          STAGE
                        </option>
                        <option value="Hindi">STAGE</option>
                      </select>
                      <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{ left: "77px", top: "40px",width:"130px",padding:"0px 10px" }}
                                >
                                  Search Stage
                                </span>
                    </li>
                    <li className="newuserTooltip">
                      <select class="thm-btn brd-btn d-inline-block">
                        <option value="English" selected>
                          STATE
                        </option>
                        <option value="Hindi">STATE</option>
                      </select>
                      <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{ left: "77px", top: "40px",width:"130px" ,padding:"0px 10px"}}
                                >
                                  Search State
                                </span>
                    </li>
                  </ul>
                </div>
              </div>
            */}
          </section>
        )}
        <section
          style={{
            background: aweBG,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="ap"
        >
          {modalVisibility2 && (
            <ModalFilter2
              modalVisibility={modalVisibility2}
              setModalVisibility={setModalVisibility2}
              // sendToParent={setIsParentData}
              showPurposeOfMentorship={true}
              fromPage={"startUpDashboard"}
              allCalendarData={true}
            />
          )}
          <div className="w-100">
            <div className="spotLightHeaderText">Spotlight</div>
            {data?.length == 0 && (
              <div className="emptyListCohort">No records found</div>
            )}
            {data?.length > 2 ? (
              <div class="container viewallcohortunder">
                <div class="tab-content d-block">
                  <div class="tab-pane fade show active" id="description">
                    <div class="row justify-content-center pt-50 pb-50">
                      <Slider {...settings}>
                        {/* <div className="container"> */}
                        {data.map((item, index) => {
                          return (
                            <div>
                              <div
                                style={{
                                  padding: "10px",
                                  marginBottom: "40px",
                                }}
                              >
                                <div class="prog-img position-relative overflow-hidden newuserTooltip">
                                  <img
                                    class="img-fluid w-100"
                                    // src={item?.uploadBanner}
                                    src={item?.uploadBanner || hashImage}
                                    style={{
                                      width: "100% !important",
                                      height: "230px",
                                      backgroundColor: "#ffffff",
                                      objectFit: "fill",
                                      cursor: "pointer",
                                    }}
                                    alt=""
                                    onClick={() => {
                                      setModalData(item);
                                      setModalOpen(true);
                                    }}
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "165px",
                                      top: "196px",
                                      width: "145px",
                                    }}
                                  >
                                    View Cohort Details
                                  </span>
                                  <span class="pro-title position-absolute">
                                    Siemens Solutions for Industry Verticals
                                  </span>
                                </div>
                                <div class="img-decrp">
                                  <div className="newuserTooltip">
                                    <h4
                                      style={{
                                        fontSize: "20px",
                                        cursor: "pointer",
                                        display: "block",
                                        marginTop: "15px",
                                      }}
                                      onClick={() => {
                                        setModalData(item);
                                        setModalOpen(true);
                                      }}
                                      className="homepageFirstDescription"
                                    >
                                      {item?.program_name?.length > 25 ? (
                                        <div className="tooltipicon">
                                          {item?.program_name.slice(0, 25)}
                                          <b style={{ cursor: "pointer" }}>
                                            ...
                                          </b>
                                          <span
                                            className="tooltiptext7"
                                            style={{
                                              top: "-105px",
                                              position: "absolute",
                                              left: "21rem",
                                            }}
                                          >
                                            {item?.program_name}
                                          </span>
                                        </div>
                                      ) : (
                                        item?.program_name
                                      )}
                                    </h4>
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{
                                        left: "165px",
                                        top: "25px",
                                        width: "145px",
                                      }}
                                    >
                                      View Cohort Details
                                    </span>
                                  </div>
                                  <p
                                    style={{
                                      fontFamily: "Montserrat",
                                      fontSize: "1.1rem",
                                      color: "rgb(62, 74, 89)",
                                      height: "52.81px",
                                    }}
                                    className="homepageFirstDescription"
                                  >
                                    {/* {item?.program_desc?.slice(0, 110)} */}
                                    {item?.program_desc?.length > 65 ? (
                                      <>
                                        <div className="d-flex">
                                          <div>
                                            {item?.program_desc.slice(0, 65) +
                                              " ..."}
                                          </div>

                                          {/* <div className="tooltipicon d-flex" style={{alignItems:"flex-end"}}> 
                                  <b style={{cursor:"pointer"}}>...</b>
                                  <span
                                className="tooltiptext7"
                                style={{ top: "-105px" }}
                              >
                                  <h5 style={{ color: "#fff" }}>
                                  COHORT SESSION DESCRIPTION
                                </h5>
                                {item?.program_desc}
                              </span>
                                  </div> */}
                                        </div>
                                      </>
                                    ) : (
                                      <div className="d-flex justify-content-center">
                                        <div>{item?.program_desc}</div>
                                      </div>
                                    )}
                                  </p>
                                </div>
                                <div className="newuserTooltip top-btn">
                                  <Button
                                    variant="contained"
                                    style={{
                                      backgroundColor: "#644b9f",
                                      color: "white",
                                      fontFamily: "Montserrat",
                                      padding: "0px 30px",
                                      borderRadius: "20px",
                                      marginTop: "25px",
                                      minHeight: "2.75vh",
                                      maxWidth: "14vw",
                                      textTransform: "capitalize",
                                      minWidth:"12rem",
                                    }}
                                    onClick={() => {
                                      const value =
                                        localStorage.getItem(
                                          "SavedLoggedInData"
                                        );
                                      if (!value) {
                                        // swal(
                                        //   "Login Required!",
                                        //   "Please Login with Mentor or Startup Credentials to Join A Cohort",
                                        //   "info"
                                        // );
                                        // window.open(`/login`);
                                        history.push({
                                          pathname: "/login",
                                          state: {
                                            cohortId: item?.id,
                                            role: "mentor2",
                                          },
                                        });
                                        localStorage.setItem(
                                          "clickcohortid",
                                          item?.id
                                        );
                                      } else {
                                        localStorage.setItem("cohortWindow", "cohortsAll");
                                        window.open(
                                          `/cohort-programs/cohortView/${item?.id}`,
                                          "_blank"
                                        );
                                        // window.open(
                                        //   `/cohort-programs/all/${item?.id}`,
                                        //   "_blank"
                                        // );
                                      }
                                    }}
                                  >
                                    {!item?.cohortVisibility && (
                                      //  <div className="newuserTooltip">
                                       <img className="newCohortImgBtn" src={privateCohortBtn} />
                                       
                                      //  <span
                                      //        className="tooltiptext   tooltip-bottom"
                                      //        style={{
                                      //          left: "8px",
                                      //          width: "160px",
                                      //          height: "30px",
                                      //          top: "4rem",
                                      //        }}
                                      //      >
                                      //        Private Cohort
                                      //      </span>
                                      //      </div>
                                    )}
                                    Read More
                                  </Button>
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "174px",
                                      top: "70px",
                                      width: "245px",
                                    }}
                                  >
                                         {!item?.cohortVisibility ? "Private Cohort, Click to Read More " : "Public Cohort, Click to Read More"} 
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div class="container viewallcohortunder">
                <div class="tab-content d-block">
                  <div class="tab-pane fade show active" id="description">
                    <div class="row justify-content-left pt-50 pb-50">
                      {/* <Slider {...settings}> */}
                      {/* <div className="container"> */}
                      {data.map((item, index) => {
                        return (
                          <div class="col-4">
                            <div
                              style={{ padding: "10px", marginBottom: "40px" }}
                            >
                              <div class="prog-img position-relative overflow-hidden">
                                <img
                                  class="img-fluid w-100"
                                  src={item?.uploadBanner}
                                  style={{
                                    width: "100% !important",
                                    height: "230px",
                                    objectFit: "cover",
                                  }}
                                  alt=""
                                />
                                <span class="pro-title position-absolute">
                                  Siemens Solutions for Industry Verticals
                                </span>
                              </div>
                              <div class="img-decrp">
                                <h4
                                  style={{
                                    fontSize: "20px",
                                  }}
                                  className="img-decrpdata"
                                >
                                  {item?.program_name?.length > 25 ? (
                                    <div className="tooltipicon">
                                      {item?.program_name.slice(0, 25)}
                                      <b style={{ cursor: "pointer" }}>...</b>
                                      <span
                                        className="tooltiptext7"
                                        style={{
                                          top: "-105px",
                                          position: "absolute",
                                          left: "23rem",
                                        }}
                                      >
                                        <h5 style={{ color: "#fff" }}>
                                          COHORT PROGRAM TITLE
                                        </h5>
                                        {item?.program_name}
                                      </span>
                                    </div>
                                  ) : (
                                    item?.program_name
                                  )}
                                </h4>
                                {item?.program_desc?.length > 65 ? (
                                  <>
                                    <div className="d-flex">
                                      <div>
                                        {item?.program_desc.slice(0, 65) +
                                          " ..."}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div className="d-flex justify-content-center">
                                    <div>{item?.program_desc}</div>
                                  </div>
                                )}
                              </div>
                              <div className="newuserTooltip top-btn">
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "#644b9f",
                                    color: "white",
                                    fontFamily: "Montserrat",
                                    padding: "0px 30px",
                                    borderRadius: "20px",
                                    marginTop: "25px",
                                    minHeight: "2.75vh",
                                    maxWidth: "14vw",
                                    minWidth:"12rem",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() => {
                                    const value =
                                      localStorage.getItem("SavedLoggedInData");
                                    if (!value) {
                                      // swal(
                                      //   "Login Required!",
                                      //   "Please Login with Mentor or Startup Credentials to Join A Cohort",
                                      //   "info"
                                      // );
                                      // window.open(`/login`);
                                      history.push({
                                        pathname: "/login",
                                        state: {
                                          cohortId: item?.id,
                                          role: "mentor2",
                                        },
                                      });
                                      localStorage.setItem(
                                        "clickcohortid",
                                        item?.id
                                      );
                                    } else {
                                      localStorage.setItem("cohortWindow", "cohortsAll");
                                      window.open(
                                        `/cohort-programs/cohortView/${item?.id}`,
                                        "_blank"
                                      );
                                      // window.open(
                                      //   `/cohort-programs/all/${item?.id}`,
                                      //   "_blank"
                                      // );
                                    }
                                  }}
                                >
                                  {!item?.cohortVisibility && (
                                    //  <div className="newuserTooltip">
                                     <img className="newCohortImgBtn" src={privateCohortBtn} />
                                     
                                    //  <span
                                    //        className="tooltiptext   tooltip-bottom"
                                    //        style={{
                                    //          left: "8px",
                                    //          width: "160px",
                                    //          height: "30px",
                                    //          top: "4rem",
                                    //        }}
                                    //      >
                                    //        Private Cohort
                                    //      </span>
                                    //      </div>
                                  )}
                                  Read More
                                </Button>
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "174px",
                                    top: "70px",
                                    width: "245px",
                                  }}
                                >
                                         {!item?.cohortVisibility ? "Private Cohort, Click to Read More " : "Public Cohort, Click to Read More"} 
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {/* </Slider> */}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div class="w-100 pt-20 pb-20">
            <div class="container ">
              <div class="row"></div>
              {/* {data?.length > 0 && ( */}
              <div className="activeProgramRow">
                {/* <div
                    className="newuserTooltip "
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <button
                      className="top-btn"
                      onClick={() => {
                        // !cohortRole
                        //   ? //
                        // history.push("./login")
                        // () => {
                        //   let value =
                        //     localStorage.getItem("SavedLoggedInData");
                        //   //
                        //   let Data = JSON.parse(value);
                        //   //

                        //   history.push({
                        //     pathname: "/login",
                        //     state: Data,
                        //   });
                        // }
                        // clickedOffline()
                        // history.push({
                        //   pathname: "/login",
                        //   state: { role: "viewallcohort" },
                        // })
                        // history.push("/login")
                        // : window.open(`/cohort-programs/all/`, "_blank");
                        // history.push('/cohort-programs/all')
                        window.open(`/cohort-programs/all/`, "_blank");
                      }}
                      style={{
                        backgroundColor: "#816aaf",
                        color: "white",
                        fontFamily: "Montserrat",
                        fontWeight: "bold",
                        padding: "5px 20px",
                        borderRadius: "20px",
                        minWidth:"22rem"
                      }}
                    >
                      VIEW ALL COHORTS
                    </button>
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ top: "45px", width: "175px", left: "48%" }}
                    >
                      Click to View All Cohorts
                    </span>
                  </div> */}

                <div
                  className="dashboard-bottom-btn top-btn  newuserTooltip "
                  onClick={() =>{
                    localStorage.setItem("cohortWindow", "cohortsAll");
                     window.open(`/cohort-programs/all/`, "_blank")
                    }}
                >
                  <p
                    style={{ cursor: "pointer", color: "white" }}
                    className="createcohortsessionbtnpara"
                  >
                    VIEW ALL COHORTS
                  </p>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "150px", top: "60px", width: "250px" }}
                  >
                    Click to View All Cohorts
                  </span>
                </div>
                <div
                  className="dashboard-bottom-btn top-btn  newuserTooltip "
                  onClick={() => setModalVisibility2(true)}
                >
                  <p
                    style={{ cursor: "pointer", color: "white" }}
                    className="createcohortsessionbtnpara"
                  >
                    COHORTS EVENTS CALENDAR
                  </p>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "150px", top: "60px", width: "250px" }}
                  >
                    Click to View Cohorts Event Calendar
                  </span>
                </div>
              </div>

              {/* )} */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
